<div class="card kpi-purple">
    <div class="card-body kpi-card">
        <h5 class="card-title">Rendement net <i class="fa fa-question-circle" matTooltipClass="tooltip-button" matTooltip="C’est un rendement net avant impot. Rendement net = 12 * (Total des loyers - Total des charges) / Total du projet"></i></h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.efficiency_net | number: '1.1-1' }} %
            </ng-container>
        </p>
    </div>
</div>
